import React, { SyntheticEvent } from "react";
import { ItemProps } from "../interfaces";
import { useBrowserOnly } from "app/main/hooks";
import { calcTransform } from "../functions";

export const ItemComponent = ({ children, active, hideDesktop, url, title, moved, isAd }: ItemProps) => {
    const browser = useBrowserOnly();
    const classNames = [];

    if (children && children.length) {
        classNames.push("subParent");
    }

    if (active) {
        classNames.push("active");
    }

    if (hideDesktop) {
        classNames.push("hideDesktop");
    }

    if (isAd) {
        classNames.push("isAd");
    }

    const handleSubNaviClick = (event: SyntheticEvent) => {
        event.stopPropagation();
        event.preventDefault();
        if (event.currentTarget && event.currentTarget.parentElement) {
            event.currentTarget.parentElement.classList.toggle("open");
        }
    };

    return (
        <React.Fragment>
            <a href={url} className={classNames.join(" ")}>
                {title}
                {children && children.length > 0 && <span className="toggle" onClick={handleSubNaviClick}></span>}
            </a>
            {children && children.length > 0 && (
                <div className="sub" style={calcTransform(browser, moved, true)}>
                    {children.map((props, i) => (
                        <ItemComponent key={i} {...props} />
                    ))}
                </div>
            )}
        </React.Fragment>
    );
};
